export default __webpack_public_path__ + "static/media/ISKO CLASS-10 EXAM PATTERN 2025.74237c2b.pdf";